import * as React from 'react';

import { hygraphClient } from '@/lib/graphql-clients';
import { getSdk, TemplateSetting } from '@/lib/types';

import DefaultLayout from '@/components/layout/default-layout';
import Link, { LinkVariant } from '@/components/link';
import Seo from '@/components/Seo';
import Typography from '@/components/typography';

import { TemplateSettingSlug } from '@/enums/template-setting-slug';
import { routes } from '@/utils/route-utils';

interface NotFoundPageProps {
  templateSetting?: TemplateSetting;
}

export default function NotFoundPage(props: NotFoundPageProps) {
  return (
    <DefaultLayout>
      <Seo templateTitle='Not Found' />

      <main className='flex min-h-[70vh] grow flex-col'>
        <section className='flex grow flex-col'>
          <div className='layout mb-24 flex grow flex-col items-center justify-center gap-16 text-center'>
            <Typography.Display3>Page not found</Typography.Display3>

            <Link
              href={props.templateSetting?.logoUrl || routes.home()}
              variant={LinkVariant.PRIMARY_BUTTON}
            >
              <Typography.Button1>Back to Home</Typography.Button1>
            </Link>
          </div>
        </section>
      </main>
    </DefaultLayout>
  );
}

export const getStaticData = async () => {
  const sdk = getSdk(hygraphClient(false));

  const templateSetting = await sdk.TemplateSetting({
    slug: TemplateSettingSlug.DEFAULT,
  });

  return {
    props: {
      templateSetting,
    },
  };
};
